import { createAsyncThunk } from "@reduxjs/toolkit";
import { cancelBookingByDatesApi, saveBookingByAdsApi, setBookingDatesBlockedByOwnerApi, updateBookingPriceByDateApi, validateBookingByDateApi } from "../../api/adsApi";
import i18n from "../../i18n";
import type { CountryValue } from "../country/countrySlice";


export type SaveBookingPayload = {
  id_ads: string;
  bookingDates: string[];
  priceByDay: number;
  booked: boolean;
  id_user?: string;
  user?: {
    email?: string;
    firstName: string;
    lastName: string;
    phone?: string;
    codeCountry?: string;
    indicatif?: string;
    country: CountryValue;
    status: string;
    password?: string;
  };
};

export type ValidateBookingByDatePayload = {
  id_user: string;
  id_ads: string;
  date: string;
  booked: boolean;
};

export type CancelBookingByDatesPayload = {
  id_user: string;
  id_ads: string;
  bookingDates: string[];
};

export type UpdateBookingPriceByDatePayload = {
  id_user: string;
  id_ads: string;
  date?: string;
  bookingDates?: string[];
  priceByDay: number;
};

export type SetBookingDatesBlockedByOwnerPayload = {
  id_user: string;
  id_ads: string;
  date?: string;
  bookingDates?: string[];
  blocked: boolean;
};

export const saveBooking = createAsyncThunk<
  any,
  SaveBookingPayload,
  { rejectValue: string }
>(
  "booking/saveBookingByAds",
  async (payload, thunkAPI) => {
    try {
      const response = await saveBookingByAdsApi(payload);
      return response.data;
    } catch (err: any) {
      const apiData = err?.response?.data;
      const message =
        (typeof apiData === "string" && apiData) ||
        apiData?.msg ||
        apiData?.message ||
        apiData?.error ||
        apiData?.fr ||
        i18n.t("system.saveBookingError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const validateBookingByDate = createAsyncThunk<
  any,
  ValidateBookingByDatePayload,
  { rejectValue: string }
>(
  "booking/validateBookingByDate",
  async (payload, thunkAPI) => {
    try {
      const response = await validateBookingByDateApi(payload);
      return response.data;
    } catch (err: any) {
      const apiData = err?.response?.data;
      const message =
        (typeof apiData === "string" && apiData) ||
        apiData?.msg ||
        apiData?.message ||
        apiData?.error ||
        apiData?.fr ||
        i18n.t("system.validateBookingError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const cancelBookingByDates = createAsyncThunk<
  any,
  CancelBookingByDatesPayload,
  { rejectValue: string }
>(
  "booking/cancelBookingByDates",
  async (payload, thunkAPI) => {
    try {
      const response = await cancelBookingByDatesApi(payload);
      return response.data;
    } catch (err: any) {
      const apiData = err?.response?.data;
      const message =
        (typeof apiData === "string" && apiData) ||
        apiData?.msg ||
        apiData?.message ||
        apiData?.error ||
        apiData?.fr ||
        i18n.t("system.deleteBookingDatesError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateBookingPriceByDate = createAsyncThunk<
  any,
  UpdateBookingPriceByDatePayload,
  { rejectValue: string }
>(
  "booking/updateBookingPriceByDate",
  async (payload, thunkAPI) => {
    try {
      const response = await updateBookingPriceByDateApi(payload);
      return response.data;
    } catch (err: any) {
      const apiData = err?.response?.data;
      const message =
        (typeof apiData === "string" && apiData) ||
        apiData?.msg ||
        apiData?.message ||
        apiData?.error ||
        apiData?.fr ||
        i18n.t("adDetails.updatePriceError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const setBookingDatesBlockedByOwner = createAsyncThunk<
  any,
  SetBookingDatesBlockedByOwnerPayload,
  { rejectValue: string }
>(
  "booking/setBookingDatesBlockedByOwner",
  async (payload, thunkAPI) => {
    try {
      const response = await setBookingDatesBlockedByOwnerApi(payload);
      return response.data;
    } catch (err: any) {
      const apiData = err?.response?.data;
      const message =
        (typeof apiData === "string" && apiData) ||
        apiData?.msg ||
        apiData?.message ||
        apiData?.error ||
        apiData?.fr ||
        i18n.t("adDetails.blockDatesError");
      return thunkAPI.rejectWithValue(message);
    }
  }
);
